<template>
    <div dir="rtl">
        <!-- شاشة تحميل -->
        <div v-if="isLoading" class="loading-screen">
            <div class="spinner"></div>
            <p>جاري التحميل...</p>
        </div>

        <!-- صفحة المراجعة -->
        <div v-else class="review-container">
            <div class="card">
                <div class="card-header">
                    <h2 class="mb-0">مراجعة البيانات المدخلة</h2>
                    <p style="color: green">رقم المناظرة : {{ this.examId }}</p>
                    <br />

                    <h3 class="text-muted mb-0">
                        يرجى مراجعة المعلومات المدخلة قبل التأكيد
                    </h3>
                </div>

                <div class="card-body">
                    <!-- المعلومات الشخصية -->
                    <div class="section mb-4">
                        <h4 class="section-title">المعلومات الشخصية</h4>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >الاسم الكامل:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.fullName ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >اسم الأب:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.fatherName ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >تاريخ الولادة:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.birthDate ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold">الجنس:</label>
                                <p class="form-value">
                                    {{ registrationFormData.sex || "غير محدد" }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >مكان الولادة:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.birthPlace ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >الولاية:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.governorate ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >رقم بطاقة التعريف:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.nationalId ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >تاريخ الإصدار:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.issueDate ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >العنوان:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.address ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >الترقيم البريدي:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.postalCode ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >رقم الهاتف:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.phone || "غير محدد"
                                    }}
                                </p>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >البريد الإلكتروني:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.email || "غير محدد"
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- المعلومات الأكاديمية حسب ID -->
                    <div class="section mb-4">
                        <h4 class="section-title">المعلومات الأكاديمية</h4>

                        <!-- للمعرفات من 25/01 إلى 25/14 -->
                        <div
                            v-if="
                                isIdInRange([
                                    '25/01',
                                    '25/02',
                                    '25/03',
                                    '25/04',
                                    '25/05',
                                    '25/06',
                                    '25/07',
                                    '25/08',
                                    '25/09',
                                    '25/10',
                                    '25/11',
                                    '25/12',
                                    '25/13',
                                    '25/14',
                                ])
                            "
                        >
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >شهادة البكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacSpecialization ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي لامتحان
                                        الباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacScore ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >الشهادة العلمية المتحصَّل عليها
                                        :</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.universityDegree ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >معدل سنةالتخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div v-if="isIdInRange(['25/15'])">
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >نوع الشهادة:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.diplomaType ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <!-- بكالوريا -->
                            <div
                                v-if="
                                    registrationFormData.diplomaType ===
                                    'بكالوريا'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >شهادة البكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacSpecialization ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي لامتحان
                                        الباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacScore ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>

                            <!-- مؤهل تقني مهني -->
                            <div
                                v-if="
                                    registrationFormData.diplomaType ===
                                    'مؤهل تقني مهني'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >الاختصاص:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.techSpecialization ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold">
                                        مؤسسة التكوين المهني:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.trainingCenter ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >سنة الحصول على شهادة مؤهَّل تقني
                                        مهني:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >معدل الحصول على شهادة مؤهَّل تقني
                                        مهني:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.techScore ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/16 -->
                        <div v-if="isIdInRange(['25/16'])">
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >اختصاص شهادة الباكالوريا:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.bacSpecialization ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >المعدل النهائي للباكالوريا:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.bacScore ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label fw-bold"
                                    >نوع الشهادة العلمية:</label
                                >
                                <p class="form-value">
                                    {{
                                        registrationFormData.degreeType ||
                                        "غير محدد"
                                    }}
                                </p>
                            </div>

                            <!-- مؤهل تقني مهني -->
                            <div
                                v-if="
                                    registrationFormData.degreeType ===
                                    'تقني سامي مساعد مديرية'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>

                            <div
                                v-if="
                                    registrationFormData.degreeType ===
                                    'شهادة معادلة'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType ===
                                        'شهادة معادلة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >الشهادة المتحصّل عليها:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.obtainedDegree ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/17 -->
                        <div v-if="isIdInRange(['25/17'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >اختصاص شهادة الباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacSpecialization17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacScore17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >نوع الشهادة:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.degreeType17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType17 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType17 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >الشهادة المتحصل عليها:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.obtainedDegree17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType17 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType17 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold">
                                        معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType17 ===
                                        'مؤهل تقني سامي في الكيمياء'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.institution17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType17 ===
                                        'مؤهل تقني سامي في الكيمياء'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType17 ===
                                        'مؤهل تقني سامي في الكيمياء'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore17 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/18 -->
                        <div v-if="isIdInRange(['25/18'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >اختصاص شهادة الباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacSpecialization18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacScore18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >نوع الشهادة:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.degreeType18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType18 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType18 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >الشهادة المتحصل عليها:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.obtainedDegree18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType18 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType18 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold">
                                        معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType18 ===
                                        'مؤهل تقني سامي في الهندسة الميكانيكية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType18 ===
                                        'مؤهل تقني سامي في الهندسة الميكانيكية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType18 ===
                                        'مؤهل تقني سامي في الهندسة الميكانيكية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore18 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/19 -->
                        <div v-if="isIdInRange(['25/19'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >اختصاص شهادة الباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacSpecialization19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacScore19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >نوع الشهادة:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.degreeType19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType19 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType19 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >الشهادة المتحصل عليها:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.obtainedDegree19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType19 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType19 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold">
                                        معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType19 ===
                                        'مؤهل تقني سامي في الهندسة الكهربائية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType19 ===
                                        'مؤهل تقني سامي في الهندسة الكهربائية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType19 ===
                                        'مؤهل تقني سامي في الهندسة الكهربائية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore19 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/20 -->
                        <div v-if="isIdInRange(['25/20'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >اختصاص شهادة الباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacSpecialization20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >معدل الباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacScore20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >نوع الشهادة:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.degreeType20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType20 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType20 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >الشهادة المتحصل عليها:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.obtainedDegree20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType20 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType20 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold">
                                        معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType20 ===
                                        'مؤهل تقني سامي في التصرف في الموارد البشرية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType20 ===
                                        'مؤهل تقني سامي في التصرف في الموارد البشرية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType20 ===
                                        'مؤهل تقني سامي في التصرف في الموارد البشرية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore20 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/21 -->
                        <div v-if="isIdInRange(['25/21'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >نوع شهادة الباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacType21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacScore21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >نوع الشهادة:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.degreeType21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType21 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType21 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >الشهادة المتحصل عليها:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.obtainedDegree21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType21 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType21 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType21 ===
                                        'مؤهّل تقني سامٍ في الإلكترونيك والكهروتقنية والآلية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType21 ===
                                        'مؤهّل تقني سامٍ في الإلكترونيك والكهروتقنية والآلية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType21 ===
                                        'مؤهّل تقني سامٍ في الإلكترونيك والكهروتقنية والآلية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore21 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/22 -->
                        <div v-if="isIdInRange(['25/22'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >نوع شهادة الباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacType22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للباكالوريا:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.bacScore22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >نوع الشهادة:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.degreeType22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType22 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType22 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >الشهادة المتحصل عليها:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.obtainedDegree22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType22 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType22 ===
                                        'إجازة'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div
                                    v-if="
                                        registrationFormData.degreeType22 ===
                                        'مؤهل تقني سامي في إدارة الأعمال: المحاسبة والمالية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >المؤسسة الجامعية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.university22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType22 ===
                                        'مؤهل تقني سامي في إدارة الأعمال: المحاسبة والمالية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div
                                    v-if="
                                        registrationFormData.degreeType22 ===
                                        'مؤهل تقني سامي في إدارة الأعمال: المحاسبة والمالية'
                                    "
                                    class="col-md-6 mb-3"
                                >
                                    <label class="form-label fw-bold"
                                        >معدل سنة التخرج:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore22 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/23 -->
                        <div v-if="isIdInRange(['25/23'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold">
                                        شهادة مؤهل تقني مهني:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.techCert23 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >مؤسسة التكوين المهني :</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.trainingCenter23 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold">
                                        سنة الحصول على شهادة مؤهل تقني
                                        مهني:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationYear23 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >معدل الحصول على شهادة مؤهل تقني
                                        مهني:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.graduationScore23 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/24 -->
                        <div v-if="isIdInRange(['25/24'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المستوى الدراسي:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.studyLevel24 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للشهادة المدرسية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.finalScore24 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label fw-bold"
                                        >الشهادة العسكرية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.militaryCertOption24 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرفات 25/25 و 25/26 -->
                        <div v-if="isIdInRange(['25/25', '25/26'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المستوى الدراسي:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.studyLevel25_26 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للنجاح بالشهادة
                                        المدرسية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.finalScore25_26 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label fw-bold"
                                        >الشهادة العسكرية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.militaryCertOption25_26 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/27 -->
                        <div v-if="isIdInRange(['25/27'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المستوى الدراسي:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.studyLevel25_27 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للنجاح بالشهادة
                                        المدرسية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.finalScore25_27 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >شهائد التكوين المهني مع شهادة
                                        تنظير:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.professionalWarning25_27 ===
                                            "نعم"
                                                ? "نعم"
                                                : registrationFormData.professionalWarning25_27 ===
                                                    "لا"
                                                  ? "لا"
                                                  : "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/28 -->
                        <div v-if="isIdInRange(['25/28'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المستوى الدراسي:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.studyLevel25_28 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للنجاح بالشهادة
                                        المدرسية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.finalScore25_28 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >شهائد التكوين المهني مع شهادة
                                        تنظير</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.professionalWarning25_28 ===
                                            "نعم"
                                                ? "نعم"
                                                : registrationFormData.professionalWarning25_28 ===
                                                    "لا"
                                                  ? "لا"
                                                  : "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرف 25/29 -->
                        <div v-if="isIdInRange(['25/29'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المستوى الدراسي:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.studyLevel25_29 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للنجاح بالشهادة
                                        المدرسية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.finalScore25_29 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >شهائد التكوين المهني مع شهادة
                                        تنظير:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.professionalWarning25_29 ===
                                            "نعم"
                                                ? "نعم"
                                                : registrationFormData.professionalWarning25_29 ===
                                                    "لا"
                                                  ? "لا"
                                                  : "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرفات 25/30 إلى 25/33 -->
                        <div
                            v-if="
                                isIdInRange([
                                    '25/30',
                                    '25/31',
                                    '25/32',
                                    '25/33',
                                ])
                            "
                        >
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للنجاح بالشهادة
                                        المدرسية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.finalScore25_30_33 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- للمعرفات 25/34 و 25/35 -->
                        <div v-if="isIdInRange(['25/34', '25/35'])">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >المعدل النهائي للشهادة المدرسية:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.finalScore25_34_35 ||
                                            "غير محدد"
                                        }}
                                    </p>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label fw-bold"
                                        >متحصل على رخصة سياقة B+C+D:</label
                                    >
                                    <p class="form-value">
                                        {{
                                            registrationFormData.drivingLicense25_34_35 ===
                                            "نعم"
                                                ? "نعم"
                                                : registrationFormData.drivingLicense25_34_35 ===
                                                    "لا"
                                                  ? "لا"
                                                  : "غير محدد"
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="action-buttons mt-4 d-flex justify-content-between"
                    >
                        <button
                            @click="openModal"
                            :disabled="!captchaToken || isSubmitting"
                            class="btn btn-primary"
                        >
                            {{
                                isSubmitting
                                    ? "جاري الإرسال..."
                                    : "تأكيد الإرسال"
                            }}
                        </button>

                        <!-- الـ Modal -->
                        <div v-if="showModal" class="modal-overlay">
                            <div class="modal-content">
                                <h3>تأكيد الإرسال</h3>
                                <p>
                                    ⚠️ تنبيه: بمجرد إرسال البيانات لن تتمكن من
                                    تعديلها، ويسمح لك بالتعبئة مرة واحدة فقط.
                                </p>
                                <div class="modal-actions">
                                    <button
                                        class="btn btn-danger"
                                        @click="confirmSubmit"
                                    >
                                        نعم، متأكد
                                    </button>
                                    <button
                                        class="btn btn-secondary"
                                        @click="closeModal"
                                    >
                                        إلغاء
                                    </button>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-secondary" @click="goBack">
                            تعديل البيانات
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div ref="captchaContainer" style="margin-top: 16px"></div>
        <p v-if="!captchaToken" style="font-size: 0.9rem; color: gray">
            إلزامي: يتوجب عليك وضع علامة في مربع التحقق reCAPTCHA قبل المتابعة.
        </p>
    </div>
</template>

<script>
import { jsPDF } from "jspdf";
import ConcoursService from "@/services/concoursService.js";
import AmiriFont from "@/assets/Amiri/Amiri-Regular.ttf";
import { useToast } from "vue-toastification";

export default {
    props: {},
    name: "ReviewForm",
    data() {
        return {
            siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            captchaToken: null,
            captchaRendered: false,
            isSubmitting: false,
            showModal: false,
            registrationFormData: {
                fullName: "",
                fatherName: "",
                birthDate: "",
                sex: "",
                birthPlace: "",
                governorate: "",
                nationalId: "",
                issueDate: "",
                address: "",
                postalCode: "",
                phone: "",
                email: "",
                bacSpecialization: "",
                bacScore: "",
                universityDegree: "",
                university: "",
                graduationYear: "",
                graduationScore: "",
            },
            examId: "",
            isLoading: true,
            pdfData: null,
        };
    },
    mounted() {
        // load the script if it isn't loaded yet
        if (!window.grecaptcha) {
            const script = document.createElement("script");
            script.src =
                "https://www.google.com/recaptcha/api.js?render=explicit";
            script.async = true;
            script.defer = true;
            script.onload = () => {
                window.grecaptcha.ready(() => {
                    this.renderRecaptcha();
                });
            };
            document.head.appendChild(script);
        } else {
            // already loaded somewhere else
            window.grecaptcha.ready(() => {
                this.renderRecaptcha();
            });
        }
        this.loadFormData();
    },
    methods: {
        renderRecaptcha() {
            if (this.captchaRendered || !this.$refs.captchaContainer) return;

            window.grecaptcha.render(this.$refs.captchaContainer, {
                sitekey: this.siteKey,
                callback: this.onCaptchaSuccess,
            });

            this.captchaRendered = true;
        },

        onCaptchaSuccess(token) {
            this.captchaToken = token;
            // you can store token to send to backend later
        },

        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        confirmSubmit() {
            this.isSubmitting = true;
            this.showModal = false;
            this.submitForm();
        },
        async getImageBase64(imgPath) {
            const response = await fetch(imgPath);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        // 🔹 تحميل البيانات من localStorage
        loadFormData() {
            try {
                const savedData = localStorage.getItem("registrationFormData");
                const savedUserId =
                    localStorage.getItem("examId") || this.$route.params.id;

                if (savedData) {
                    this.registrationFormData = JSON.parse(savedData);
                }

                this.examId = savedUserId;

                setTimeout(() => {
                    this.isLoading = false;
                }, 1000);
            } catch (error) {
                console.error("خطأ في تحميل البيانات:", error);
                this.isLoading = false;
            }
        },

        // 🔹 تحقق من أن المعرف موجود ضمن مجموعة محددة
        isIdInRange(idArray) {
            return idArray.includes(this.examId);
        },

        // 🔹 العودة للتعديل
        goBack() {
            this.$router.push("/formcom");
        },

        // 🔹 دالة تحويل ArrayBuffer إلى Base64
        arrayBufferToBase64(buffer) {
            let binary = "";
            const bytes = new Uint8Array(buffer);
            const chunkSize = 0x8000;
            for (let i = 0; i < bytes.length; i += chunkSize) {
                const chunk = bytes.subarray(i, i + chunkSize);
                binary += String.fromCharCode.apply(null, chunk);
            }
            return btoa(binary);
        },

        calculateScore() {
            let score = 0;
            const data = this.registrationFormData;
            const id = this.examId;

            // للمناظرات 25/01 إلى 25/14
            const standardIds = [
                "25/01",
                "25/02",
                "25/03",
                "25/04",
                "25/05",
                "25/06",
                "25/07",
                "25/08",
                "25/09",
                "25/10",
                "25/11",
                "25/12",
                "25/13",
                "25/14",
            ];

            if (standardIds.includes(id)) {
                score =
                    parseFloat(data.graduationScore) * 1.5 +
                    parseFloat(data.bacScore) * 1;
            }

            // للمناظرة 25/15
            else if (id === "25/15") {
                if (data.diplomaType === "مؤهل تقني مهني") {
                    score = parseFloat(data.techScore) * 2.5;
                } else if (data.diplomaType === "بكالوريا") {
                    score = parseFloat(data.bacScore) * 2.5;
                }
            }

            // للمناظرة 25/16
            else if (id === "25/16") {
                if (data.degreeType === "تقني سامي مساعد مديرية") {
                    score =
                        parseFloat(data.graduationScore) * 1.5 +
                        parseFloat(data.bacScore) * 1;
                } else if (data.degreeType === "شهادة معادلة") {
                    score =
                        parseFloat(data.graduationScore) * 1.5 +
                        parseFloat(data.bacScore) * 1;
                }
            }

            // للمناظرة 25/17
            else if (id === "25/17") {
                score =
                    parseFloat(data.bacScore17) * 1 +
                    parseFloat(data.graduationScore17) * 1.5;
            }

            // للمناظرة 25/18
            else if (id === "25/18") {
                score =
                    parseFloat(data.graduationScore18) * 1.5 +
                    parseFloat(data.bacScore18) * 1;
            }

            // للمناظرة 25/19
            else if (id === "25/19") {
                score =
                    parseFloat(data.graduationScore19) * 1.5 +
                    parseFloat(data.bacScore19) * 1;
            }

            // للمناظرة 25/20
            else if (id === "25/20") {
                score =
                    parseFloat(data.graduationScore20) * 1.5 +
                    parseFloat(data.bacScore20) * 1;
            }

            // للمناظرة 25/21
            else if (id === "25/21") {
                score =
                    parseFloat(data.graduationScore21) * 1.5 +
                    parseFloat(data.bacScore21) * 1;
            }

            // للمناظرة 25/22
            else if (id === "25/22") {
                score =
                    parseFloat(data.graduationScore22) * 1.5 +
                    parseFloat(data.bacScore22) * 1;
            }

            // للمناظرة 25/23
            else if (id === "25/23") {
                score = parseFloat(data.graduationScore23) * 2.5;
            }

            // تقريب النتيجة لرقمين عشريين
            return parseFloat(score.toFixed(2));
        },

        // 🔹 إرسال البيانات وإنشاء PDF
        async submitForm() {
            const toast = useToast();
            toast.info("جاري معالجة طلبك، يرجى الانتظار...");
            this.isSubmitting = true;

            try {
                // 🔹 تصفية البيانات الفارغة
                const filteredData = {};
                for (const key in this.registrationFormData) {
                    if (
                        this.registrationFormData[key] !== "" &&
                        this.registrationFormData[key] !== null
                    )
                        filteredData[key] = this.registrationFormData[key];
                }
                if (!filteredData.email) {
                    filteredData.email = "غير محدد";
                }
                filteredData.examId = this.examId;
                filteredData.score = this.calculateScore();
                filteredData.captchaToken = this.captchaToken;

                // 🔹 إرسال البيانات للسيرفر
                this.pdfData = (
                    await ConcoursService.create(filteredData)
                ).data;
                console.log("Server Response:", this.pdfData);

                // 🔹 تحميل الخط العربي وتحويله إلى Base64
                const fontResponse = await fetch(AmiriFont);
                const fontBuffer = await fontResponse.arrayBuffer();
                const fontBase64 = this.arrayBufferToBase64(fontBuffer);

                const doc = new jsPDF({
                    orientation: "p",
                    unit: "mm",
                    format: "a4",
                });

                // 🔹 تحميل الخط العربي الجديد
                doc.addFileToVFS("Scheherazade-Regular.ttf", fontBase64);
                doc.addFont(
                    "Scheherazade-Regular.ttf",
                    "Scheherazade",
                    "normal",
                );
                doc.setFont("Scheherazade"); // الخط الجديد

                // 🔹 أبعاد الصفحة
                const pageWidth = 210;
                let y = 2;

                const logoBase64 = await this.getImageBase64(
                    require("@/assets/logo.png"),
                );
                const logoWidth = 20;
                const logoHeight = 20;
                const xLogo = (pageWidth - logoWidth) / 2;
                doc.addImage(
                    logoBase64,
                    "PNG",
                    xLogo,
                    y,
                    logoWidth,
                    logoHeight,
                );
                y += logoHeight + 15;

                // 🔹 كتابة العنوان تحت اللوغو في الوسط
                doc.setFontSize(17);

                doc.text(
                    "إيصال التسجيل في مناظرة الإنتداب الخاصة بالشركة التونسية لصناعات التكرير لسنة 2025",
                    pageWidth / 2,
                    y,
                    { align: "center" },
                );
                const data = this.pdfData;

                doc.setFontSize(15);
                // 🔹 تغيير اللون للأحمر
                doc.setTextColor(255, 0, 0);
                // 🔹 رقم المناظرة
                doc.text(
                    `رقم المناظرة : ${this.examId}`,
                    pageWidth / 2,
                    y + 15,
                    { align: "center" },
                );
                doc.text(
                    `رقم التسجيل : ${data.num_inscription || "غير محدد"}`,
                    pageWidth / 2,
                    y + 25,
                    { align: "center" },
                );
                y += 15;

                doc.setTextColor(0, 0, 0);
                // 🔹 بعد العنوان، نكتب البيانات الشخصية والأكاديمية مباشرة
                doc.setFontSize(12);

                console.log("PDF Data in pdf:", data);
                y += 22;
                // 🔹 كتابة المعلومات الشخصية
                const personalFields = [
                    { label: "الاسم الكامل", key: "fullName" },
                    { label: "اسم الأب", key: "fatherName" },
                    { label: "تاريخ الولادة", key: "birthDate" },
                    { label: "الجنس", key: "sex" },
                    { label: "مكان الولادة", key: "birthPlace" },
                    { label: "الولاية", key: "governorate" },
                    { label: "رقم بطاقة التعريف", key: "nationalId" },
                    { label: "تاريخ الإصدار", key: "issueDate" },
                    { label: "العنوان", key: "address" },
                    { label: "الترقيم البريدي", key: "postalCode" },
                    { label: "رقم الهاتف", key: "phone" },
                    { label: "البريد الإلكتروني", key: "email" },
                ];

                personalFields.forEach((field) => {
                    doc.text(
                        `${field.label}: ${data[field.key]}`,
                        pageWidth - 20,
                        y,
                        { align: "right" },
                    );
                    y += 10;
                });

                const academicIds = [
                    "25/01",
                    "25/02",
                    "25/03",
                    "25/04",
                    "25/05",
                    "25/06",
                    "25/07",
                    "25/08",
                    "25/09",
                    "25/10",
                    "25/11",
                    "25/12",
                    "25/13",
                    "25/14",
                ];
                if (academicIds.includes(this.examId)) {
                    const academicFields = [
                        {
                            label: "اختصاص شهادة الباكالوريا",
                            key: "bacSpecialization",
                        },
                        {
                            label: "المعدل النهائي للباكالوريا",
                            key: "bacScore",
                        },
                        {
                            label: "الشهادة العلمية المتحصَّل عليها",
                            key: "universityDegree",
                        },
                        { label: "المؤسسة الجامعية", key: "university" },
                        { label: "سنة التخرج", key: "graduationYear" },
                        { label: "معدل سنة التخرج", key: "graduationScore" },
                    ];
                    const marginRight = 20;
                    academicFields.forEach((field) => {
                        doc.text(
                            `${field.label}: ${data.extra_data[field.key]}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;
                    });
                }

                const marginRight = 20;

                if (this.examId === "25/15") {
                    doc.text(
                        `نوع الشهادة: ${data.extra_data.diplomaType || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    if (data.extra_data.diplomaType === "بكالوريا") {
                        const bacFields = [
                            {
                                label: "شهادة البكالوريا",
                                key: "bacSpecialization",
                            },
                            {
                                label: "المعدل النهائي للباكالوريا",
                                key: "bacScore",
                            },
                        ];
                        bacFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }

                    if (data.extra_data.diplomaType === "مؤهل تقني مهني") {
                        const techFields = [
                            { label: "الاختصاص", key: "techSpecialization" },
                            {
                                label: "مؤسسة التكوين المهني",
                                key: "trainingCenter",
                            },
                            {
                                label: "سنة الحصول على شهادة مؤهَّل تقني مهني",
                                key: "graduationYear",
                            },
                            {
                                label: "معدل الحصول على شهادة مؤهَّل تقني مهني",
                                key: "techScore",
                            },
                        ];
                        techFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }
                }

                if (this.examId === "25/16") {
                    doc.text(
                        `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `المعدل النهائي للباكالوريا: ${data.extra_data.bacScore || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `نوع الشهادة: ${data.extra_data.degreeType || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    if (
                        data.extra_data.degreeType === "تقني سامي مساعد مديرية"
                    ) {
                        const bacFields = [
                            { label: "المؤسسة الجامعية", key: "university" },
                            { label: "سنة التخرج", key: "graduationYear" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore",
                            },
                        ];
                        bacFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }

                    if (data.extra_data.degreeType === "شهادة معادلة") {
                        const techFields = [
                            { label: "المؤسسة الجامعية", key: "university" },
                            {
                                label: "الشهادة المحصل عليها",
                                key: "obtainedDegree",
                            },
                            { label: "سنة التخرج", key: "graduationYear" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore",
                            },
                        ];
                        techFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }
                }

                // 🔹 كتابة المعلومات الأكاديمية إذا كان المعرف 25/17
                if (this.examId === "25/17") {
                    // الباك
                    doc.text(
                        `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization17 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `المعدل النهائي للباكالوريا: ${data.extra_data.bacScore17 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `نوع الشهادة: ${data.extra_data.degreeType17 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    // في حالة إجازة
                    if (data.extra_data.degreeType17 === "إجازة") {
                        const licenseFields = [
                            { label: "المؤسسة الجامعية", key: "university17" },
                            {
                                label: "الشهادة المحصل عليها",
                                key: "obtainedDegree17",
                            },
                            { label: "سنة التخرج", key: "graduationYear17" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore17",
                            },
                        ];
                        licenseFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }

                    // في حالة مؤهل تقني سامي في الكيمياء
                    if (
                        data.extra_data.degreeType17 ===
                        "مؤهل تقني سامي في الكيمياء"
                    ) {
                        const techFields = [
                            { label: "المؤسسة الجامعية", key: "institution17" },
                            { label: "سنة التخرج", key: "graduationYear17" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore17",
                            },
                        ];
                        techFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }
                }

                // 🔹 كتابة المعلومات الأكاديمية إذا كان المعرف 25/18
                if (this.examId === "25/18") {
                    // الباك
                    doc.text(
                        `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization18 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `المعدل النهائي للباكالوريا: ${data.extra_data.bacScore18 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `نوع الشهادة: ${data.extra_data.degreeType18 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    // في حالة إجازة
                    if (data.extra_data.degreeType18 === "إجازة") {
                        const licenseFields = [
                            { label: "المؤسسة الجامعية", key: "university18" },
                            {
                                label: "الشهادة المتحصل عليها",
                                key: "obtainedDegree18",
                            },
                            { label: "سنة التخرج", key: "graduationYear18" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore18",
                            },
                        ];
                        licenseFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }

                    // في حالة مؤهل تقني سامي في الهندسة الميكانيكية
                    if (
                        data.extra_data.degreeType18 ===
                        "مؤهل تقني سامي في الهندسة الميكانيكية"
                    ) {
                        const techFields = [
                            { label: "المؤسسة الجامعية", key: "university18" },
                            { label: "سنة التخرج", key: "graduationYear18" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore18",
                            },
                        ];
                        techFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }
                }

                // 🔹 كتابة المعلومات الأكاديمية إذا كان المعرف 25/19
                if (this.examId === "25/19") {
                    // الباك
                    doc.text(
                        `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization19 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `المعدل النهائي للباكالوريا: ${data.extra_data.bacScore19 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `نوع الشهادة: ${data.extra_data.degreeType19 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    // في حالة إجازة
                    if (data.extra_data.degreeType19 === "إجازة") {
                        const licenseFields = [
                            { label: "المؤسسة الجامعية", key: "university19" },
                            {
                                label: "الشهادة المتحصل عليها",
                                key: "obtainedDegree19",
                            },
                            { label: "سنة التخرج", key: "graduationYear19" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore19",
                            },
                        ];
                        licenseFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }

                    // في حالة مؤهل تقني سامي في الهندسة الكهربائية
                    if (
                        data.extra_data.degreeType19 ===
                        "مؤهل تقني سامي في الهندسة الكهربائية"
                    ) {
                        const techFields = [
                            { label: "المؤسسة الجامعية", key: "university19" },
                            { label: "سنة التخرج", key: "graduationYear19" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore19",
                            },
                        ];
                        techFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }
                }

                // 🔹 كتابة المعلومات الأكاديمية إذا كان المعرف 25/20
                if (this.examId === "25/20") {
                    // الباك
                    doc.text(
                        `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization20 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `معدل الباكالوريا: ${data.extra_data.bacScore20 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `نوع الشهادة: ${data.extra_data.degreeType20 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    // في حالة إجازة
                    if (data.extra_data.degreeType20 === "إجازة") {
                        const licenseFields = [
                            { label: "المؤسسة الجامعية", key: "university20" },
                            {
                                label: "الشهادة المتحصل عليها",
                                key: "obtainedDegree20",
                            },
                            { label: "سنة التخرج", key: "graduationYear20" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore20",
                            },
                        ];
                        licenseFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }

                    // في حالة مؤهل تقني سامي في التصرف في الموارد البشرية
                    if (
                        data.extra_data.degreeType20 ===
                        "مؤهل تقني سامي في التصرف في الموارد البشرية"
                    ) {
                        const techFields = [
                            { label: "المؤسسة الجامعية", key: "university20" },
                            { label: "سنة التخرج", key: "graduationYear20" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore20",
                            },
                        ];
                        techFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }
                }

                if (this.examId === "25/21") {
                    // الباك
                    doc.text(
                        `اختصاص شهادة الباكالوريا: ${data.extra_data.bacType21 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `معدل الباكالوريا: ${data.extra_data.bacScore21 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `نوع الشهادة: ${data.extra_data.degreeType21 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    // في حالة إجازة
                    if (data.extra_data.degreeType21 === "إجازة") {
                        const licenseFields = [
                            { label: "المؤسسة الجامعية", key: "university21" },
                            {
                                label: "الشهادة المتحصل عليها",
                                key: "obtainedDegree21",
                            },
                            { label: "سنة التخرج", key: "graduationYear21" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore21",
                            },
                        ];
                        licenseFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }

                    // في حالة مؤهل تقني سامي في التصرف في الموارد البشرية
                    if (
                        data.extra_data.degreeType21 ===
                        "مؤهّل تقني سامٍ في الإلكترونيك والكهروتقنية والآلية"
                    ) {
                        const techFields = [
                            { label: "المؤسسة الجامعية", key: "university21" },
                            { label: "سنة التخرج", key: "graduationYear21" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore21",
                            },
                        ];
                        techFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }
                }

                if (this.examId === "25/22") {
                    // الباك
                    doc.text(
                        `اختصاص شهادة الباكالوريا: ${data.extra_data.bacType22 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `معدل الباكالوريا: ${data.extra_data.bacScore22 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `نوع الشهادة: ${data.extra_data.degreeType22 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    // في حالة إجازة
                    if (data.extra_data.degreeType22 === "إجازة") {
                        const licenseFields = [
                            { label: "المؤسسة الجامعية", key: "university22" },
                            {
                                label: "الشهادة المتحصل عليها",
                                key: "obtainedDegree22",
                            },
                            { label: "سنة التخرج", key: "graduationYear22" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore22",
                            },
                        ];
                        licenseFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }

                    // في حالة مؤهل تقني سامي في التصرف في الموارد البشرية
                    if (
                        data.extra_data.degreeType22 ===
                        "مؤهل تقني سامي في إدارة الأعمال: المحاسبة والمالية"
                    ) {
                        const techFields = [
                            { label: "المؤسسة الجامعية", key: "university22" },
                            { label: "سنة التخرج", key: "graduationYear22" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore22",
                            },
                        ];
                        techFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }
                }

                if (this.examId === "25/23") {
                    doc.text(
                        `شهادة مؤهل تقني مهني : ${data.extra_data.techCert23 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `مؤسسة التكوين المهني : ${data.extra_data.trainingCenter23 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `سنة الحصول على شهادة مؤهل تقني مهني: ${data.extra_data.graduationYear23 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `معدل الحصول على شهادة مؤهل تقني مهني : ${data.extra_data.graduationScore23 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;
                }

                if (this.examId === "25/24") {
                    doc.text(
                        `المستوى الدراسي : ${data.extra_data.studyLevel24 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `المعدل النهائي للشهادة المدرسية : ${data.extra_data.finalScore24 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `الشهادة العسكرية : ${data.extra_data.militaryCertOption24 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;
                }

                if (this.examId === "25/25" || this.examId === "25/26") {
                    doc.text(
                        `المستوى الدراسي : ${data.extra_data.studyLevel25_26 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_26 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `الشهادة العسكرية : ${data.extra_data.militaryCertOption25_26 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;
                }

                if (this.examId === "25/27") {
                    doc.text(
                        `المستوى الدراسي : ${data.extra_data.studyLevel25_27 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_27 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `شهائد التكوين المهني مع شهادة تنظير: ${data.extra_data.professionalWarning25_27 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;
                }

                if (this.examId === "25/28") {
                    doc.text(
                        `المستوى الدراسي : ${data.extra_data.studyLevel25_28 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_28 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `شهائد التكوين المهني مع شهادة تنظير: ${data.extra_data.professionalWarning25_28 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;
                }

                if (this.examId === "25/29") {
                    doc.text(
                        `المستوى الدراسي : ${data.extra_data.studyLevel25_29 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_29 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `شهائد التكوين المهني مع شهادة تنظير: ${data.extra_data.professionalWarning25_29 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;
                }

                if (
                    this.examId === "25/30" ||
                    this.examId === "25/31" ||
                    this.examId === "25/32" ||
                    this.examId === "25/33"
                ) {
                    doc.text(
                        `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_30_33 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;
                }

                if (this.examId === "25/34" || this.examId === "25/35") {
                    doc.text(
                        `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_34_35 || "غير محدد"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    doc.text(
                        `رخصة السياقة من الصنف B+C+D: ${data.extra_data.drivingLicense25_34_35 || "غير محدد"}`,
                        pageWidth - marginRight, // البداية من أقصى اليمين
                        y,
                        { align: "right" }, // محاذاة من اليمين
                    );
                    y += 10;
                }

                let scoreFormula = "";

                if (academicIds.includes(data.examId)) {
                    scoreFormula =
                        ")معدل سنةالتخرج × 1.5( + )معدل شهادةالباكالوريا × 1(";
                } else if (data.examId === "25/15") {
                    if (data.extra_data.diplomaType === "مؤهل تقني مهني") {
                        scoreFormula = ")معدل مؤهل تقني مهني × 2.5(";
                    } else if (data.extra_data.diplomaType === "بكالوريا") {
                        scoreFormula = ")معدل شهادةالباكالوريا × 2.5(";
                    }
                } else if (data.examId === "25/16") {
                    scoreFormula =
                        ")معدل سنةالتخرج × 1.5( + )معدل شهادةالباكالوريا × 1(";
                } else if (
                    [
                        "25/17",
                        "25/18",
                        "25/19",
                        "25/20",
                        "25/21",
                        "25/22",
                    ].includes(data.examId)
                ) {
                    scoreFormula =
                        ")معدل التخرج × 1.5( + )معدل الباكالوريا × 1(";
                } else if (data.examId === "25/23") {
                    scoreFormula = ")معدل شهادة مؤهل تقني مهني × 2.5(";
                }

                doc.text(
                    `النقاط المتحصل عليها${scoreFormula ? " )" + scoreFormula + "(" : ""}: ${data.score || "لا شئ"}`,
                    pageWidth - marginRight,
                    y,
                    { align: "right" },
                );
                y += 10;

                // 🔹 حفظ PDF
                doc.save("registration.pdf");
                localStorage.clear();

                // 🔹 إشعار النجاح
                toast.success("تم إرسال البيانات وإنشاء ملف PDF بنجاح!");

                // 🔹 إعادة التوجيه بعد 5 ثواني
                setTimeout(() => this.$router.push("/"), 5000);
            } catch (error) {
                console.error("خطأ في الإرسال أو إنشاء PDF:", error);
                toast.error(
                    "حدث خطأ أثناء الإرسال أو إنشاء الملف. حاول مرة أخرى.",
                );
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>

<style scoped>
.loading-screen {
    position: fixed;
    inset: 0;
    background: linear-gradient(135deg, var(--primary), var(--primary-light));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    z-index: 9999;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid var(--accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.review-container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
}

.card {
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #ddd;
    padding: 20px;
    border-radius: 10px 10px 0 0;
}

.card-body {
    padding: 25px;
}

.section {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    background-color: #fafafa;
}

.section-title {
    color: #333;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #007bff;
}

.form-label {
    color: #555;
    font-size: 14px;
    margin-bottom: 5px;
}

.form-value {
    background-color: white;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-bottom: 10px;
    min-height: 38px;
    display: flex;
    align-items: center;
    color: #333;
}

.action-buttons {
    display: flex;
    justify-content: space-between;
    /* باش الزرين يكونوا بعيد على أقصى اليمين و اليسار */
    padding-top: 20px;
    border-top: 1px solid #eee;
}

.btn {
    padding: 15px 25px;
    font-size: 16px;
    margin: 0 10px;
    border-radius: 12px;
}

.btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
    color: white;
    order: 2;
    display: inline-block;
}

.btn-secondary:hover {
    background-color: #545b62;
    border-color: #545b62;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.alert {
    border-radius: 5px;
    padding: 15px;
}

.alert-success {
    background-color: #d4edda;
    border-color: #c3e6cb;
    color: #155724;
}

.alert-danger {
    background-color: #f8d7da;
    border-color: #f5c6cb;
    color: #721c24;
}

/* تحسين التصميم للشاشات الصغيرة */
@media (max-width: 768px) {
    .review-container {
        padding: 10px;
    }

    .card-body {
        padding: 15px;
    }

    .action-buttons .btn {
        margin: 5px 0;
        width: 100%;
    }

    .col-md-6 {
        margin-bottom: 15px;
    }

    .action-buttons {
        flex-direction: column;
        /* يصبحوا عموديين */
        align-items: stretch;
        /* ياخذوا عرض كامل */
    }

    .action-buttons .btn {
        width: 100%;
        /* كل زر ياخذ عرض كامل */
        margin: 5px 0;
    }
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    width: 400px;
    text-align: center;
}

.modal-actions {
    margin-top: 15px;
    display: flex;
    justify-content: space-around;
}
</style>
